import React from 'react';
import Modal from '../Modal/Modal';
import ReauthHero from './ReauthHero';
import ReauthOtpForm from './ReauthOtpForm';
import ReauthPasswordForm from './ReauthPasswordForm';
import useReauth, { REAUTH_STEPS } from '../../../Hooks/useReauth';
import { useTempEdgeTranslator } from '../../../Hooks/useTranslation';
import { getLoginUsername } from '../../../utils/helpers/sessionStore';
import { getReauthIcon } from './reauthIcons';
import { getReauthDescriptionKey, REAUTH_TEXT_KEYS } from './reauthTexts';
import '../../../assets/styles/components/ReauthModal.css';

const ReauthModal = () => {
  const { reason, step, errorKey, isSubmitting, handlePasswordSubmit, handleOtpSubmit, handleLeave } = useReauth();
  const { tempedgeTranslator: text } = useTempEdgeTranslator();

  const ReasonIcon = getReauthIcon(reason);
  const isOtpStep = step === REAUTH_STEPS.otp;

  const content = (
    <div className="te-reauth" data-testid="reauth-modal">
      <ReauthHero icon={ReasonIcon} title={text(REAUTH_TEXT_KEYS.signIn)} description={text(getReauthDescriptionKey(reason))} />
      {errorKey && (
        <p className="te-reauth-error" role="alert" data-testid="reauth-error">
          {text(errorKey)}
        </p>
      )}
      {isOtpStep ? (
        <ReauthOtpForm isSubmitting={isSubmitting} onSubmit={handleOtpSubmit} onLeave={handleLeave} />
      ) : (
        <ReauthPasswordForm
          defaultUsername={getLoginUsername()}
          isSubmitting={isSubmitting}
          onSubmit={handlePasswordSubmit}
          onLeave={handleLeave}
        />
      )}
    </div>
  );

  return <Modal variant="action" topmost open={Boolean(reason)} modalSize={null} content={content} />;
};

export default ReauthModal;
